import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { FiMenu } from 'react-icons/fi';
import { MdClose } from 'react-icons/md';
import { FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';
import { navLinksdata } from '../../constants';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="sticky top-0 z-50 w-full bg-bodyColor/80 backdrop-blur-md border-b-[1px] border-b-gray-800"
    >
      <div className="max-w-screen-xl mx-auto h-24 flex justify-between items-center px-4">
        <div>
          {/* Logo / Brand */}
          <h1 className="text-3xl font-bold font-titleFont text-white tracking-wider cursor-pointer">
            PORT<span className="text-designColor">FOLIO</span>
          </h1>
        </div>

        <div>
          <ul className="hidden mdl:inline-flex items-center gap-6 lg:gap-10">
            {navLinksdata.map(({ _id, title, link }) => (
              <li
                className="text-base font-normal text-gray-400 tracking-wide cursor-pointer relative group overflow-hidden"
                key={_id}
              >
                <Link
                  activeClass="active"
                  to={link}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                  className="group-hover:text-designColor transition-colors duration-300"
                >
                  {title}
                </Link>
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-designColor transition-all group-hover:w-full duration-300"></span>
              </li>
            ))}
          </ul>

          {/* Mobile menu button */}
          <span
            onClick={() => setShowMenu(!showMenu)}
            className="text-xl mdl:hidden bg-black w-10 h-10 inline-flex items-center justify-center rounded-full text-designColor cursor-pointer hover:shadow-neon transition-all duration-300"
          >
            <FiMenu />
          </span>

          {/* Mobile menu */}
          {showMenu && (
            <motion.div
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ duration: 0.3 }}
              className="w-[80%] h-screen overflow-scroll absolute top-0 right-0 bg-[#191b1e] p-4 scrollbar-hide z-50 border-l border-gray-800 shadow-2xl"
            >
              <div className="flex flex-col gap-8 py-2">
                <div className="flex justify-between items-center">
                  <h2 className="text-2xl font-bold font-titleFont text-white">Menu</h2>
                  <span
                    onClick={() => setShowMenu(false)}
                    className="text-gray-400 hover:text-designColor duration-300 text-2xl cursor-pointer"
                  >
                    <MdClose />
                  </span>
                </div>

                <ul className="flex flex-col gap-4">
                  {navLinksdata.map(item => (
                    <li
                      key={item._id}
                      className="text-base font-normal text-gray-400 tracking-wide cursor-pointer hover:text-designColor transition-all duration-300 border-b-[1px] border-gray-800 pb-2"
                    >
                      <Link
                        onClick={() => setShowMenu(false)}
                        activeClass="active"
                        to={item.link}
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                      >
                        {item.title}
                      </Link>
                    </li>
                  ))}
                </ul>

                <div className="flex flex-col gap-4">
                  <h2 className="text-base uppercase font-titleFont mb-4 tracking-widest text-gray-200">
                    Find me on
                  </h2>
                  <div className="flex gap-4">
                    <span className="bannerIcon hover:text-designColor hover:shadow-neon transition-all duration-300">
                      <FaFacebookF />
                    </span>
                    <span className="bannerIcon hover:text-designColor hover:shadow-neon transition-all duration-300">
                      <FaTwitter />
                    </span>
                    <span className="bannerIcon hover:text-designColor hover:shadow-neon transition-all duration-300">
                      <FaLinkedinIn />
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Navbar;
